function getParameterByName(name) {
    let urlParams;
    try {
        urlParams = decodeURIComponent(window.location.search);
    } catch (e) {
        urlParams = '';
    }
    const match = RegExp('[?&]' + name + '=([^&]*)').exec(urlParams);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

import config from 'config';
import _ from 'underscore';
import Backbone from 'backbone';
import QuestionCollection from './QuestionCollection';
import * as Logger from '../Logger';
import Global from 'models/Global';
import axios from '../libs/axiosLib'; // TODO: why not axios?
var Poll = Backbone.Model.extend({

    initialize: function(options) {
        this.set('questions', new QuestionCollection(this.get('questions')));

        this.get('questions').each(function(question) {
            this.listenTo(question, 'change:answer', this.questionAnswered);
        }, this);

    },

    isPollActive: function() {
        var now = new Date().getTime();
        if (this.get('endTimestamp')){
            return (this.get('startTimestamp') < now && now < this.get('endTimestamp'));
        } else {
            return this.get('startTimestamp') < now;
        }

    },

    questionAnswered: function(question, answer){
        this.set('pollCompleted', this.allMandatoryQuestionAnswered());
    },

    allMandatoryQuestionAnswered: function() {
        var allAnswered = true;
        this.get('questions').each(function(question){
            allAnswered = allAnswered && (!question.get('mandatory') || question.get('answer'));
        }, this);
        return allAnswered;
    },

    vote: function(options) {
        this.generateUniqueVoteToken(options.cookie);
        var thisModel = this;
        Logger.sendLog('error', `####  POLLS ERROR is poll completed ==> ${this.get('pollCompleted')} polld is ${this.get('id')}`);

        options = options || {};

        var success = options.success;
        options.success = function() {
            Logger.sendLog('error', '####  POLLS SUUCESS ==> success');
            success && success();
            thisModel.set('voted', true);
        };
        var error = options.error;
        options.error = function(err) {
            try {
                Logger.sendLog('error', `####  POLLS ERROR ==> error ${JSON.stringify(err)}`);
            } catch (e) {
                Logger.sendLog('error', '####  POLLS ERROR ==> error NO STRINGIFY ERROR');
            }
            error && error(err);
        };

        const data = thisModel.parseToVote(options.cookie);
        try {
            Logger.sendLog('error', `####  POLLS ERROR ==> sending ajax ${JSON.stringify(data)}`);
        } catch (e) {
            Logger.sendLog('error', '####  POLLS ERROR ==> sending ajax NO STRINGIFY');
        }

        if (getParameterByName('inApp')) {
            const http = axios.create({
                baseURL: config.apiServer
            });
            try {
                const response = http.post(`${config.baseV2Url}/polls/${thisModel.get('id')}/vote`, data);
                options.success(response);
                return;
            } catch (e) {
                options.error(e);
                return;
            }
        } else {
            Backbone.ajax({
                url: `${config.baseV2Url}/polls/${thisModel.get('id')}/vote`,
                method: 'POST',
                data: data,
                success: options.success,
                error: options.error
            });
        }

    },

    isWL: function() {
        return Global.get('event').get('websiteType') === 'whitelabel';
    },

    parseToVote: function(cookie) {
        const questionsWithAnswers = this.get('questions').filter(question => question.has('answer'));

        return {
            votes: questionsWithAnswers.map(function(question){
                const res = {
                    'questionId': question.get('id')
                };
                if (question.get('entryType') === 'TEXT'){
                    res.text = question.get('answer');
                } else {
                    res.answerId = question.get('answer');
                }
                return res;
            }),
            'x-bz-vote-id': cookie('x-bz-vote-id')
        };
    },

    generateUniqueVoteToken: function(cookie) {
        Logger.sendLog('error', `####  POLLS ERROR generate bz-vote cookie ==> ${cookie('x-bz-vote-id')} polld is ${this.get('id')}`);
        if (!cookie('x-bz-vote-id')){
            var components = config.apiServer.split('.');
            var rootDomain = components.splice(components.length - 2).join('.');

            cookie('x-bz-vote-id', Math.random().toString(36).substring(7), {
                expires: 3650,
                secure: true,
                domain: rootDomain,
                path: '/'
            });
        }
    },

    clearResults: function(options) {
        var thisModel = this;
        options = options || {};

        var success = options.success;
        options.success = function() {
            success && success();
        };

        var error = options.error;
        options.error = function(err) {
            error && error();
        };

        Backbone.ajax({
            url: '/api/v1/organizer/polls/' + this.get('id') + '/reset',
            method: 'POST',
            success: options.success,
            error: options.error
        });

    },

    startPoll: function(options) {
        this.set('startTimestamp', Date.now());
        this.unset('endTimestamp');
        this.save();
    },

    stopPoll: function(options) {
        this.set('endTimestamp', Date.now());
        this.save();
    },

    toJSON: function(options) {
        var toJSON = Backbone.Model.prototype.toJSON.call(this);
        toJSON.partner = (toJSON.partner && toJSON.partner.toJSON()) || [];
        var forSave = options && _.has(options, 'emulateJSON');
        return forSave ? { poll: toJSON } : toJSON;
    },

    parse: function(response) {
        response.action = this.getPollAction(response);
        return response;
    },

    getPollAction: function(poll) {
        var now = new Date().getTime();

        if ((poll.startMethod === 'manual' && !poll.startTimestamp) || (now < poll.startTimestamp)) {
            return 'notActiveYet';
        }

        if (!poll.voted && (!poll.endTimestamp || now < poll.endTimestamp)){
            return 'takePoll';
        }

        if (poll.voted) {
            if (poll.showResults){
                return 'viewResults';
            } else {
                return 'completed';
            }
        }

        if (poll.endTimestamp && now > poll.endTimestamp){
            if (poll.showResults){
                return 'viewResults';
            } else {
                return 'pollEnded';
            }
        }

        return undefined;
    }

});

export default Poll;

